import { render, staticRenderFns } from "./DataTableOrder.vue?vue&type=template&id=194e07dc&"
import script from "./DataTableOrder.vue?vue&type=script&lang=js&"
export * from "./DataTableOrder.vue?vue&type=script&lang=js&"
import style0 from "./DataTableOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports